// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"2860d30b4c063802","apps_pwi_src_app_components_personal-wealth-inventory_personal-wealth-inventory_component_ts":"d5bff2079630d678","apps_pwi_src_app_components_client-data_client-data_component_ts":"fab04a954518d9cd"}[chunkId] + ".js";
};